module.exports = __webpack_public_path__ + "img/terminkalender.70c720a5.svg";